<template>
    <div class="add-temp">
        <el-form ref="elForm" :model="rowData" :rules="rules" size="medium" label-width="160px" label-suffix="：">
            <el-form-item :label="$t('setup.phone')" prop="phone">
                {{rowData.phone}}
            </el-form-item>
            <el-form-item :label="$t('setup.email')" prop="email">
                {{rowData.email}}
            </el-form-item>
            <el-form-item :label="$t('setup.username')" prop="username">
                {{rowData.username}}
            </el-form-item>
        </el-form>
        <div class="boontbtn">
            <el-button type="info" size="small" @click="clearAdd">{{$t('common.close')}}</el-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "add",
        props:{
            rowData:{
                type: Object,
                default() {
                    return {};
                }
            },
            dialogType:{
                type: String,
                default() {
                    return '';
                }
            },
        },
        data() {
            return {
                rules: {
                    phone: [{
                        required: true,
                        message: this.$t('common.pleaseEnter')+this.$t('setup.phone')+'!',
                        trigger: 'blur'
                    }], email: [{
                        required: true,
                        message: this.$t('common.pleaseEnter')+this.$t('setup.email')+'!',
                        trigger: 'blur'
                    }], username: [{
                        required: true,
                        message: this.$t('common.pleaseEnter')+this.$t('setup.username')+'!',
                        trigger: 'blur'
                    }], password: [{
                        required: true,
                        message: this.$t('common.pleaseEnter')+this.$t('setup.psw')+'!',
                        trigger: 'blur'
                    }],
                }
            }
        },
        methods: {
            submitForm() {
                this.$refs['elForm'].validate(valid => {
                    if (!valid) {
                        this.$message.error(this.$t('common.pleaseComplete'));
                        return false
                    }else {
                        this.$emit("add",this.rowData)
                    }
                })
            },
            clearAdd() {
                this.formData = {};
                this.$emit("clear");
            },
        },
        mounted() {

        }
    }
</script>

<style scoped>

</style>
